/**
 * Get the referrer of the document.
 * Primarily used to mock the referrer in tests.
 */
export function getDocumentReferrer() {
  return document.referrer;
}